import Button from '@mui/material/Button';
import Grid from '@mui/material/Unstable_Grid2';
import Stack from '@mui/material/Stack';
import { EmptyState } from '@backstage/core-components';
import {
  EntityLinksCard,
  EntityOrphanWarning,
  EntityProcessingErrorsPanel,
  EntityRelationWarning,
  EntitySwitch,
  hasCatalogProcessingErrors,
  hasRelationWarnings,
  isOrphan,
} from '@backstage/plugin-catalog';
import { EntityFossaCard } from '@backstage-community/plugin-fossa';
import { EntityGrafanaDashboardsCard } from '@backstage-community/plugin-grafana';
import {
  EntityGithubActionsContent,
  isGithubActionsAvailable,
} from '@backstage-community/plugin-github-actions';
import { EntitySonarQubeCard } from '@backstage-community/plugin-sonarqube';
import { isSonarQubeAvailable } from '@backstage-community/plugin-sonarqube-react';
import {
  AliasesCard,
  ServiceRelationshipsCard,
  StakeholdersCard,
  EntityAboutCard,
  ServiceSlackCard,
  isFossaAvailable,
} from '@internal/plugin-medidata-catalog-react';
import {
  MaturityScoreContent,
  MaturitySummaryContent,
  MaturitySummaryInfoCard,
} from '@internal/plugin-maturity';

import { getReusableDashboards } from '../utils';

export const maturityScoreContent = <MaturityScoreContent />;
export const maturitySummaryContent = <MaturitySummaryContent />;

export const entityWarningContent = (
  <>
    <EntitySwitch>
      <EntitySwitch.Case if={isOrphan}>
        <EntityOrphanWarning />
      </EntitySwitch.Case>
    </EntitySwitch>

    <EntitySwitch>
      <EntitySwitch.Case if={hasRelationWarnings}>
        <EntityRelationWarning />
      </EntitySwitch.Case>
    </EntitySwitch>

    <EntitySwitch>
      <EntitySwitch.Case if={hasCatalogProcessingErrors}>
        <EntityProcessingErrorsPanel />
      </EntitySwitch.Case>
    </EntitySwitch>
  </>
);

export const CICDContent = (
  // This is an example of how you can implement your company's logic in entity page.
  // You can for example enforce that all components of type 'service' should use GitHubActions
  <EntitySwitch>
    <EntitySwitch.Case if={isGithubActionsAvailable}>
      <EntityGithubActionsContent />
    </EntitySwitch.Case>
    <EntitySwitch.Case>
      <EmptyState
        title="No CI/CD available for this entity"
        missing="info"
        description="You need to add an annotation to your component if you want to enable CI/CD for it. You can read more about annotations in Backstage by clicking the button below."
        action={
          <Button
            variant="contained"
            color="primary"
            href="https://backstage.io/docs/features/software-catalog/well-known-annotations"
          >
            Read more
          </Button>
        }
      />
    </EntitySwitch.Case>
  </EntitySwitch>
);

export const commonContent = (
  <>
    <Grid md={5} xs={10}>
      <Stack spacing={1}>
        <EntityAboutCard />
        {entityWarningContent}
        <AliasesCard />
        <StakeholdersCard />
      </Stack>
    </Grid>
    <Grid md={4} xs={8}>
      <Stack spacing={1}>
        <ServiceSlackCard />
        <EntityLinksCard />
        <EntitySwitch>
          <EntitySwitch.Case if={entity => entity.spec?.type === 'service'}>
            <EntityGrafanaDashboardsCard
              title="Vision Dashboards"
              paged
              pageSize={5}
              additionalDashboards={getReusableDashboards}
            />
          </EntitySwitch.Case>
        </EntitySwitch>
        <ServiceRelationshipsCard />
      </Stack>
    </Grid>

    <Grid md={3} xs={6}>
      <Stack spacing={1}>
        <MaturitySummaryInfoCard />
        <EntitySwitch>
          <EntitySwitch.Case if={isSonarQubeAvailable}>
            <EntitySonarQubeCard variant="gridItem" />
          </EntitySwitch.Case>
        </EntitySwitch>

        <EntitySwitch>
          <EntitySwitch.Case if={isFossaAvailable}>
            <EntityFossaCard variant="gridItem" />
          </EntitySwitch.Case>
        </EntitySwitch>
      </Stack>
    </Grid>
  </>
);
